import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { fetchApi, logoutFromSession } from '../lib/api'

interface AuthState {
  isAuthenticated: boolean
  hydrated: boolean
  apiKey: string | null
  setAuthenticated: (value: boolean) => void
  setApiKey: (key: string | null) => void
  logout: () => Promise<void>
  hydrate: () => Promise<void>
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      hydrated: false,
      apiKey: null,
      setAuthenticated: (value) => set({ isAuthenticated: value }),
      setApiKey: (key) => set({ apiKey: key }),
      logout: async () => {
        try {
          await logoutFromSession()
        } catch {
          // Best-effort cleanup; clear local state regardless.
        }
        set({ isAuthenticated: false, apiKey: null })
      },
      hydrate: async () => {
        try {
          await fetchApi('/v1/profile')
          set({ isAuthenticated: true, hydrated: true })
        } catch {
          set({ isAuthenticated: false, hydrated: true })
        }
      },
    }),
    {
      name: 'orzforge-auth',
      partialize: (state) =>
        ({
          isAuthenticated: state.isAuthenticated,
          apiKey: state.apiKey,
        }) as AuthState,
    },
  ),
)
